import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p440726801590865920',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
